import React from 'react';

const Measure = ({ str, index }) => {
  return (
    <span>
      {str}
      {index && <sup style={{ fontSize: '10px' }}>{index}</sup>}
    </span>
  );
};

export default Measure;
